import React, { forwardRef } from 'react'
import {
  Checkbox,
  ListItemText,
  MenuItem,
  MenuItemProps,
  Typography,
} from '@mui/material'

export interface SelectableMenuItemProps extends MenuItemProps {
  readonly name: React.ReactNode
  readonly selected: boolean
}
const SelectableMenuItem = forwardRef<HTMLLIElement, SelectableMenuItemProps>(
  function SelectableMenuItem({ name, selected, ...props }, ref) {
    return (
      <MenuItem ref={ref} {...props}>
        <Checkbox checked={selected} />
        <ListItemText
          primary={
            <Typography noWrap color="secondary">
              {name}
            </Typography>
          }
        />
      </MenuItem>
    )
  },
)

export default SelectableMenuItem
